import {DateRange} from '../../../stores/TimeIntervalStore';
import {TableSort, TableSortDirection} from '../../Table';
import {
    CampaignKPI,
    DescriptiveKPIAdditions,
    KPIGroupKey,
    ProductKPI,
    ProductSlopeOutlierKPI,
    SearchtermKPI,
    SearchtermSlopeOutlierKPI,
} from '../../../kpi';

export type TableMode = 'searchterm' | 'product' | 'campaign';

export interface TableDataForChannelRequest {
    targetCurrency?: string;
    mode: TableMode;
    channel: string;
    interval: DateRange;
    search: string;
    searchExactly?: boolean;
    sorting: TableSort;
    limit: number;
    filter: string;
}

export interface ChannelCompareRequest {
    mode: string;
    channels: string[];
    interval: DateRange;
    search: string;
    sortAttribute: string | AbtestSortAttribute;
    sortDirection: TableSortDirection;
    limit: number;
    filter: string;
    targetCurrency: string;
}

export enum SortMode {
    Ratio = 'ratio',
    Variant = 'variant',
    Diff = 'diff',
}

export interface AbtestSortAttribute {
    mode: SortMode;
    kpi: string;
    variantIds?: string[];
    channel?: string;
    channels?: string[];
    testId?: string;
}

export interface AbtestCompareRequest {
    mode: string;
    channel: string;
    interval: DateRange;
    search: string;
    sortAttribute: string | AbtestSortAttribute;
    sortDirection: TableSortDirection;
    limit: number;
    filter: string;
    targetCurrency: string;
    testId: string;
    variantIds: string[];
}

export interface ChannelDataRegister {
    [channel: string]: TableDataForChannelResponse;
}

export interface TableDataForChannelResponse {
    isCompareRangeLine?: boolean;
    [KPIGroupKey.Searchterm]?: string;
    [KPIGroupKey.Channel]: string;
    [SearchtermKPI.SearchCount]?: number;
    [SearchtermSlopeOutlierKPI.SearchOutlierScore]?: number;
    [SearchtermSlopeOutlierKPI.SearchSlopeValue]?: number;
    [SearchtermKPI.ClickCount]: number;
    [SearchtermSlopeOutlierKPI.ClickOutlierScore]: number;
    [SearchtermSlopeOutlierKPI.ClickSlopeValue]: number;
    [SearchtermKPI.CartCount]: number;
    [SearchtermSlopeOutlierKPI.CartOutlierScore]: number;
    [SearchtermSlopeOutlierKPI.CartSlopeValue]: number;
    [SearchtermKPI.CheckoutCount]: number;
    [SearchtermSlopeOutlierKPI.CheckoutOutlierScore]: number;
    [SearchtermSlopeOutlierKPI.CheckoutSlopeValue]: number;
    [SearchtermKPI.UniqueClickCount]: number;
    [SearchtermKPI.SalesFromSearches]?: number;
    [ProductKPI.Sales]?: number;
    [ProductSlopeOutlierKPI.SalesOutlierScore]: number;
    [ProductSlopeOutlierKPI.SalesSlopeValue]: number;
    [SearchtermSlopeOutlierKPI.SalesFromSearchesOutlierScore]: number;
    [SearchtermSlopeOutlierKPI.SalesFromSearchesSlopeValue]: number;
    [SearchtermKPI.ResultCount]?: number;
    [SearchtermKPI.AvgResultCount]?: number;
    [SearchtermKPI.ClickRate]?: number;
    [SearchtermKPI.UniqueClickRate]?: number;
    [SearchtermKPI.ClickToCartRate]: number;
    [SearchtermKPI.ClickToBuyRate]?: number;
    [SearchtermKPI.CheckoutPerSearchRate]?: number;
    [SearchtermKPI.AvgMatchCount]?: number;
    [SearchtermKPI.AvgBestSimi]?: number;
    [SearchtermKPI.AvgPos]?: number;
    [SearchtermKPI.CartToCheckoutRate]: number;
    [SearchtermKPI.SalesFromSearchesPerSearch]?: number;
    [ProductKPI.SalesPerClick]?: number;
    [SearchtermKPI.SalesFromSearchesPerClick]?: number;
    [SearchtermKPI.AsnClickCount]: number;
    [SearchtermKPI.NaviClickCount]: number;
    [KPIGroupKey.ProductId]?: string;
    [DescriptiveKPIAdditions.Title]?: string;
    [KPIGroupKey.CampaignId]?: string;
    [CampaignKPI.Name]?: string;
    [CampaignKPI.Category]?: string;
    [CampaignKPI.Flavour]?: string;
    [CampaignKPI.AvgPushedProductsCount]?: number;
    [CampaignKPI.UniqueSearchCount]: number;
    [CampaignKPI.AvgCartValue]: number;
    [CampaignKPI.ExitRate]: number;
    [CampaignKPI.BounceRate]: number;
}

export interface TableDataForChannel extends TableDataForChannelResponse {
    channelCompareRegister?: ChannelDataRegister;
}



// WEBPACK FOOTER //
// ./src/types/api/tableData/TableDataForChannel.ts